import cookies from './cookies.json'
import ipDisclaimer from './ip-disclaimer.json'
import privacy from './privacy.json'
import terms from './terms.json'

export type LegalDocId = 'terms' | 'privacy' | 'cookies' | 'ip-disclaimer'

export type LegalDocumentMeta = {
  id: LegalDocId
  slug: string
  title: string
  company: string
  updatedLine: string
  paragraphs: string[]
}

export const LEGAL_LAST_UPDATED = 'July 3, 2026'

export const LEGAL_DOCUMENTS: Record<LegalDocId, LegalDocumentMeta> = {
  terms: {
    id: 'terms',
    slug: 'terms',
    title: 'Terms of Use',
    company: 'Zimark Corporation (致銘株式会社)',
    updatedLine: `First Issued: ${LEGAL_LAST_UPDATED}  |  Last Updated: ${LEGAL_LAST_UPDATED}`,
    paragraphs: terms.slice(4) as string[],
  },
  privacy: {
    id: 'privacy',
    slug: 'privacy',
    title: 'Privacy Policy',
    company: 'Zimark Corporation (致銘株式会社)',
    updatedLine: `Last Updated: ${LEGAL_LAST_UPDATED}`,
    paragraphs: privacy.slice(4) as string[],
  },
  cookies: {
    id: 'cookies',
    slug: 'cookies',
    title: 'Cookie Policy',
    company: 'Zimark Corporation (致銘株式会社)',
    updatedLine: `Effective Date: ${LEGAL_LAST_UPDATED}`,
    paragraphs: cookies.slice(3) as string[],
  },
  'ip-disclaimer': {
    id: 'ip-disclaimer',
    slug: 'ip-disclaimer',
    title: 'Intellectual Property and Disclaimer',
    company: '致銘株式会社 (Zimark Corporation)',
    updatedLine: 'First issued: January 12, 2025  |  Last updated: July 26, 2026',
    paragraphs: ipDisclaimer.slice(3) as string[],
  },
}

export const LEGAL_PATHS = ['/terms', '/privacy', '/cookies', '/ip-disclaimer'] as const

/** Cream marketing surfaces that use MarketingHeader (hide app Header). */
export const MARKETING_SHELL_PATHS = [
  '/partners',
  '/affiliate',
  '/affiliate/login',
  '/affiliate/register',
  '/updates',
  '/blog',
] as const
